import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios'; // Make sure axios is installed

const useScrollToTop = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
};

const CampEthiccraft = () => {
  useScrollToTop();
  const [images, setImages] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const componentRef = useRef(null);

  const goToPrevious = () => {
    setCurrentIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : images.length - 1));
  };

  const goToNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex < images.length - 1 ? prevIndex + 1 : 0));
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.unobserve(componentRef.current); // Stop observing once visible
          }
        });
      },
      { threshold: 0.2 }
    );

    if (componentRef.current) {
      observer.observe(componentRef.current);
    }

    return () => {
      if (componentRef.current) {
        observer.unobserve(componentRef.current);
      }
    };
  }, []);

  useEffect(() => {
    axios.get('https://ethiccraft.org/backend/camp_ethiccraft/read_isShown.php')
      .then(response => {
        setImages(response.data);
      })
      .catch(error => {
        console.error('Error fetching camp images:', error);
      });
  }, []);

  return (
    <div ref={componentRef} className={`design-component ${isVisible ? 'fade-in' : ''}`}>
      <div className="left-section">
        <h2 className="intro-text">
          Camps Organised by <span className="highlight"> Ethiccraft </span>
        </h2>
        <p className="description-text">  </p>
      </div>
      <div className="right-section-camps">
        <div className="camps_slider-container">
          <div
            className="slider"
            style={{ transform: `translateX(-${currentIndex * 100}%)` }}
          >
            {images.map((image, index) => (
              <div key={index} className="slide11">
                <img src={`https://ethiccraft.org/${image.image}`} className="slide-image11" />
                <div className="image-details">
                  <h3 className="image-title">{image.name}</h3>
                  <p className="image-subtitle">{image.duration}</p>
                  <div className="see-details">{image.venue} . {image.date}</div>
                </div>
              </div>
            ))}
          </div>
          <button className="slider-button prev" onClick={goToPrevious}></button>
          <button className="slider-button next" onClick={goToNext}></button>
          <div className="dots">
            {images.map((_, index) => (
              <button
                key={index}
                className={`dot ${index === currentIndex ? 'active' : ''}`}
                onClick={() => setCurrentIndex(index)}
              ></button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CampEthiccraft;
